"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = {
  input: {
    backgroundColor: 'transparent',
    color: '#373F4A',
    fontFamily: 'Arial',
    fontSize: '90%'
  },
  '.input-container.is-focus': {
    borderColor: '#ddd',
    borderWidth: '1px'
  }
};